import Vue from "vue";
import Router from "vue-router";
import Main from "./views/public/Main.vue";
import WebApp from "@/views/public/WebApp";
import MobileMain from "./views/mobile/Main.vue";
import MobilePasswordReset from "./views/mobile/NewPassword.vue";
import MobilePasswordResetPin from "./views/mobile/NewPasswordPIN.vue";
import PasswordReset from "./views/NewPassword.vue";
import PasswordResetPin from "./views/NewPasswordPIN.vue";
import Home from "./views/Home.vue";
import Chooser from "./views/Chooser.vue";
import Login from "./views/Login.vue";
import Verify from "./views/Verify.vue";
import NewPassword from "./views/NewPassword.vue";
import NewPasswordPIN from "./views/NewPasswordPIN.vue";
import Registration from "./views/Registration.vue";
import RegistrationPIN from "./views/RegistrationPIN.vue";
import LandingRegistration from "./views/LandingRegistration.vue";
import Logout from "./components/Logout.vue";
import Profile from "./views/Profile.vue";
import Messages from "./views/Messages.vue";
import Diploma from "./views/Diploma.vue";
import Prologue from "./views/Prologue.vue";
import AudioBook from "./views/AudioBook.vue";
import Question from "./views/Question.vue";
import Lingron from "./views/Lingron.vue";
import Test from "./views/Test.vue";
import TestMini from "./views/TestMini.vue";
import TestRepeat from "./views/TestRepeat.vue";
import Conversation from "./views/Conversation.vue";
import Summary from "./views/Summary.vue";
import SummaryAudioBook from "./views/SummaryAudioBook.vue";
import Overview from "./views/Overview.vue";
import Settings from "./views/Settings.vue";
import FreeLesson from "./components/freeLesson/FreeLesson.vue";
import FreePrologue from "./components/freeLesson/FreePrologue.vue";
import FreeLingron from "./components/freeLesson/FreeLingron.vue";
import FreeMiniLingron from "@/components/freeLesson/FreeMiniLingron.vue";
import FreeSummary from "./components/freeLesson/FreeSummary.vue";
import FreeTest from "./components/freeTests/Test.vue";
import FreeTestMini from "./components/freeTests/TestMini.vue";
import FreeTestRepeat from "./components/freeTests/TestRepeat.vue";
import PageNotFound from "./views/PageNotFound.vue";
import Packages from "@/views/public/Packages";
import Offer from "@/views/public/Offer";
import MiniLingron from "@/views/MiniLingron";
import MobileRegistration from "@/views/mobile/Registration";
import BusinessPage from "@/views/business-page/Main";
import SelfValue from "@/views/SelfValue";
import LeaderBoard from "@/views/LeaderBoard";

Vue.use(Router);

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    // {
    //   path: "/",
    //   name: "main",
    //   component: Main
    // },
    {
      path: "/",
      name: "main",
      component: Registration
    },
    {
      path: "/csomagok",
      name: "packages",
      component: Packages
    },
    {
      path: "/ajanlat",
      name: "offer",
      component: Offer
    },
    {
      path: "/home",
      name: "home",
      component: Home
    },
    {
      path: "/messages",
      name: "messages",
      component: Messages
    },
    {
      path: "/chooser",
      name: "chooser",
      component: Chooser
    },
    {
      path: "/web/app",
      name: "WebApp",
      component: WebApp
    },
    {
      path: "/mobile/app",
      name: "MobileMain",
      component: MobileMain
    },
    {
      path: "/mobile/registration",
      name: "MobileRegistration",
      component: MobileRegistration
    },
    {
      path: "/mobile/app/password/reset",
      name: "MobilePasswordReset",
      component: MobilePasswordReset
    },
    {
      path: "/mobile/app/password/reset/pin",
      name: "MobilePasswordResetPin",
      component: MobilePasswordResetPin
    },
    {
      path: "/app/password/reset",
      name: "PasswordReset",
      component: PasswordReset
    },
    {
      path: "/app/password/reset/pin",
      name: "PasswordResetPin",
      component: PasswordResetPin
    },
    {
      path: "/profile",
      name: "profile",
      component: Profile
    },
    {
      path: "/diploma",
      name: "diploma",
      component: Diploma
    },
    {
      path: "/settings",
      name: "settings",
      component: Settings
    },
    {
      path: "/question/:lessonId",
      name: "question",
      component: Question
    },
    {
      path: "/prologue/:lessonId/:fromLingron?",
      name: "prologue",
      component: Prologue
    },
    {
      path: "/audioBook/:lessonId/",
      name: "audioBook",
      component: AudioBook
    },
    {
      path: "/conversation/:lessonId",
      name: "conversation",
      component: Conversation
    },
    {
      path: "/test/:lessonId/",
      name: "test",
      component: Test
    },
    {
      path: "/test/mini/:lessonId/:lingronId",
      name: "testMini",
      component: TestMini
    },
    {
      path: "/test/repeat/:lessonId/",
      name: "testRepeat",
      component: TestRepeat
    },
    {
      path: "/lingron/:lessonId/",
      name: "lingron",
      component: Lingron
    },
    {
      path: "/minilingron/:lessonId/:lingronId",
      name: "miniLingron",
      component: MiniLingron
    },
    {
      path: "/summary/:lessonId/:fromAudioBook?",
      name: "summary",
      component: Summary
    },
    {
      path: "/summaryAudioBook/:lessonId",
      name: "summaryAudioBook",
      component: SummaryAudioBook
    },
    {
      path: "/overview/:lessonId",
      name: "overview",
      component: Overview
    },
    {
      path: "/selfValue/:lessonId",
      name: "selfValue",
      component: SelfValue
    },
    {
      path: "/leaderboard",
      name: "leaderBoard",
      component: LeaderBoard
    },
    {
      path: "/login",
      name: "login",
      component: Login
    },
    {
      path: "/verify",
      name: "verify",
      component: Verify
    },
    {
      path: "/newPassword",
      name: "newPassword",
      component: NewPassword
    },
    {
      path: "/newPassword/PIN",
      name: "newPasswordPIN",
      component: NewPasswordPIN
    },
    {
      path: "/registration",
      name: "registration",
      component: Registration
    },
    {
      path: "/newRegistration/PIN",
      name: "newRegistrationPIN",
      component: RegistrationPIN
    },
    {
      path: "/registration/landing",
      name: "registrationLanding",
      component: LandingRegistration
    },
    // {
    //   path: "/registration/landing/question/:lessonId",
    //   name: "registrationLandingQuestion",
    //   component: LandingRegistrationQuestion
    // },
    // {
    //   path: "/registration/landing/question/:lessonId/lingrons/:questionId",
    //   name: "registrationLandingLingron",
    //   component: LandingRegistrationLingron
    // },
    // {
    //   path: "/registration/landing/summary/:lessonId",
    //   name: "registrationLandingSummary",
    //   component: LandingRegistrationSummary
    // },
    {
      path: "/logout",
      name: "logout",
      component: Logout
    },
    {
      path: "/free/lesson/:url",
      name: "freeLesson",
      component: FreeLesson
    },
    {
      path: "/business/:url",
      name: "businessPage",
      component: BusinessPage
    },
    {
      path: "/free/lesson/prologue/:lessonId/:fromLingron?",
      name: "freePrologue",
      component: FreePrologue
    },
    {
      path: "/free/lesson/lingron/:lessonId/:lingronId",
      name: "freeLingron",
      component: FreeLingron
    },
    {
      path: "/free/lesson/miniLingron/:lessonId/:lingronId",
      name: "freeMiniLingron",
      component: FreeMiniLingron
    },
    {
      path: "/free/lesson/summary/:lessonId",
      name: "freeSummary",
      component: FreeSummary
    },
    {
      path: "/free/test/:lessonId/",
      name: "freeTest",
      component: FreeTest
    },
    {
      path: "/free/test/mini/:lessonId/:lingronId",
      name: "freeTestMini",
      component: FreeTestMini
    },
    {
      path: "/free/test/repeat/:lessonId/",
      name: "freeTestRepeat",
      component: FreeTestRepeat
    },
    {
      path: "*",
      name: "PageNotFound",
      component: PageNotFound
    },
    {
      path: "/about",
      name: "about",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/About.vue")
    }
  ]
});
